import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space, Table } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"
import { justify } from "@antv/g2plot/lib/plots/sankey/sankey";
import { useSelector } from "react-redux";
import TableAntd from "components/elements/Table/Table";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD/MM/YYYY" }) {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format(reFormat);
}

const EmployeeInfoWorkExperienceTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
}) => {
  console.log("name", dataSource);
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const columns = [
    {
      title: (
        <div className="text-table">{t("common.index")}</div>
      ),
      dataIndex: "id",
      key: "id",
      width: "8%",
      render: (text, record, index) => {
        return (
          <span
            style={{
              color: "#313131",
              backgroundColor: "#F5F6F7",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            {index + 1}
          </span>)
      }
    },
    {
      title: <div className="text-table">{t('employee.label.position')}</div>,
      dataIndex: "position",
      key: "position",
      render: (_, record) => {
        return <span style={{ color: "#42526D" }}>{record?.position ? record?.position : "-"}</span>
      }
    },
    {
      title: <div className="text-table">{t('employee.company')}</div>,
      dataIndex: "company",
      key: "company",
      width: "15%",
      render: (_, record) => {
        return <span style={{ color: "#42526D" }}>{record?.company ? record?.company : "-"}</span>
      }
    },
    {
      title: <div className="text-table">{t('employee.salary.header')}</div>,
      dataIndex: "salary",
      key: "salary",
      width: "10%",
      render: (_, record) => {
        if (record?.salary) {
          return <span style={{
            color: "#42526D", justifyContent: "end", display: "flex", alignItems: "end",
          }}>{get2DecimalPointsWithCommas(record?.salary)}</span>;
        }
      }
    },
    {
      title: <div className="text-table">{t('start-date')}</div>,
      dataIndex: "startDate",
      key: "startDate",
      render: (_, record) => {
        return <span style={{ color: "#313131" }}>{formatDate({ dateString: record?.startDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</span>
      }
    },
    {
      title: <div className="text-table">{t('end-date')}</div>,
      dataIndex: "endDate",
      key: "endDate",
      render: (_, record) => {
        return <span style={{ color: "#313131" }}>{formatDate({ dateString: record?.endDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</span>
      }
    },
    roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|WORK_EXPERIENCE", "UPDATE_EMPLOYEE|EMPLOYEE_INFO|WORK_EXPERIENCE") ? {
      title: "",
      key: "action",
      align: "center",
      width: "5%",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|WORK_EXPERIENCE") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("DELETE_EMPLOYEE|EMPLOYEE_INFO|WORK_EXPERIENCE") && {
                  key: "2",
                  onClick: () => onDelete(record),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record?.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default EmployeeInfoWorkExperienceTable;
